import { graphql } from '../../../../../../gql'

export const CompleteWhatsAppConnection = graphql(/* GraphQL */ `
  mutation CompleteWhatsAppConnection(
    $input: CompleteWhatsAppConnectionInput!
  ) {
    completeWhatsAppConnection(input: $input) {
      __typename
      ... on CompleteWhatsAppConnectionResponse {
        channel {
          id
          service
          serviceId
        }
      }
      ... on InvalidInputError {
        message
      }
      ... on NotFoundError {
        message
      }
      ... on LimitReachedError {
        message
      }
      ... on ChannelConnectionCannotStealChannelError {
        message
      }
    }
  }
`)

export const WhatsAppChannels = graphql(/* GraphQL */ `
  query WhatsAppChannels($input: ChannelsInput!) {
    channels(input: $input) {
      id
      service
      serviceId
    }
  }
`)

export const WhatsAppChannelStatus = graphql(/* GraphQL */ `
  query WhatsAppChannelStatus($input: ConfigurationInput!) {
    configuration(input: $input) {
      channels {
        channelId
        authorizationStatus {
          feature
          status
        }
      }
    }
  }
`)
